// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"850":"96f11856","1486":"3fae751a","1815":"31d6cfe0","1860":"11efcd47","2269":"31d6cfe0","4135":"394b36c3","4765":"394b36c3","6526":"31d6cfe0"}[chunkId] + ".chunk.css";
};